module.exports = __webpack_public_path__ + "img/brand-05.41d12230.png";